import { render } from "./BeziersConfig.vue?vue&type=template&id=1288cd64&scoped=true"
import script from "./BeziersConfig.vue?vue&type=script&lang=js"
export * from "./BeziersConfig.vue?vue&type=script&lang=js"

import "./BeziersConfig.vue?vue&type=style&index=0&id=1288cd64&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1288cd64"]])

export default __exports__